module.exports = __webpack_public_path__ + "img/vezapodorysy2NP.90d1b0b7.png";